export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'aaf30a5f-d4ad-4944-bbaf-855322dc0682';
export const MODAL_CLOSE_SEC = 2.5;